<template>
  <div class="backgroundSupply">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="jump()">{{$t('lang.btn_backgroundSupply')}}</el-button>
      </div>
      <el-form
        :rules="rules"
        ref="form"
        :model="form"
        class="form"
        :label-width="require('@/config/enum').c_ws4"
        :label-suffix="require('@/config/enum').c_colon"
      >
        <el-row>
          <el-col :span="5">
            <el-form-item :label="$t('lang.lab_groundSupplyAddress')" prop="value">
              <el-select v-model="form.value" @change="selectFloor">
                <el-option key :label="$t('lang.lab_chooseGarden')" value></el-option>
                <el-option
                  v-for="(item,index) in types"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item prop="floorid">
              <el-select v-model="form.floorid" @change="selectUnit">
                <el-option key :label="$t('lang.lab_floorName')" value></el-option>
                <el-option
                  v-for="(item,index) in floorList"
                  :key="index"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item prop="unitid">
              <el-select v-model="form.unitid" @change="selectRoom">
                <el-option key :label="$t('lang.lab_unitName')" value></el-option>
                <el-option
                  v-for="(item,index) in unitList"
                  :key="index"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item prop="roomid">
              <el-select v-model="form.roomid">
                <el-option key :label="$t('lang.lab_roomName')" value></el-option>
                <el-option
                  v-for="(item,index) in roomList"
                  :key="index"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <el-form-item :label="$t('lang.lab_groundSupplytype')" prop="firstLevelid">
              <el-select v-model="form.firstLevelid" @change="selectSecond">
                <el-option key :label="$t('lang.lab_firstLevel')" value></el-option>
                <el-option
                  v-for="(item,index) in firstLevellist"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item prop="secondLevelid">
              <el-select v-model="form.secondLevelid" @change="selectThird">
                <el-option key :label="$t('lang.lab_secondLevel')" value></el-option>
                <el-option
                  v-for="(item,index) in secondLevellist"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item prop="thirdLevelid">
              <el-select v-model="form.thirdLevelid">
                <el-option key :label="$t('lang.lab_thirdLevel')" value></el-option>
                <el-option
                  v-for="(item,index) in thirdLevellist"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('lang.lab_groundSupplyuser')" prop="user">
          <el-input
            maxlength="30"
            class="input"
            v-model="form.user"
            :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_groundSupplyuser')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_groundSupplyphone')" prop="tele">
          <el-input
            @input="keyBA"
            maxlength="11"
            class="input"
            v-model="form.tele"
            :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_groundSupplyphone')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_groundSupplynature')" prop="nature">
          <el-select
            v-model="form.nature"
            :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_groundSupplynature')"
            @change="selectComplaintpraisetype2"
          >
            <el-option key :label="$t('lang.lab_complainFlag')" value="0"></el-option>
            <el-option
              v-for="(item,index) in natures"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('lang.lab_groundtype')"
          prop="complaintPraiseType2"
          v-if="form.nature ==='2'||form.nature ==='3'"
        >
          <el-select class="select" v-model="form.complaintPraiseType2" 
            @change="selectComplaintpraisetype3"
          >
           <el-option key :label="$t('lang.lab_secondLevel')" value></el-option>
            <el-option
              v-for="(item,index) in secondcomplaintPraiseList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
           <el-form-item
          :label="$t('lang.lab_groundtypes')"
           prop="complaintPraiseType3"
          v-if="form.nature ==='2'||form.nature ==='3'"
        >
          <el-select class="select" v-model="form.complaintPraiseType3" >
            <el-option key :label="$t('lang.lab_thirdLevel')" value></el-option>
            <el-option
              v-for="(item,index) in thirdcomplaintPraiseList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_groundSupplycontext')" prop="context">
          <el-input
            maxlength="4000"
            class="input"
            type="textarea"
            rows="5"
            v-model="form.context"
            :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_groundSupplycontext')"
          ></el-input>
        </el-form-item>
        <!-- 图片上传 -->
        <el-form-item :label="$t('lang.lab_uploadPhotograph')" prop="files" ref="files">
          <upload-morefile ref="uploading" :accept='accept'  upTypes='1' :fileList='fileListTemp' :clears='clears' @outputFile="getFile" @removeFile='removeFile'></upload-morefile>
        </el-form-item>
        <!-- 附件上传 -->
        <el-form-item :label="$t('lang.lab_accessories')" prop="withFiles" ref="withFiles">
         <upload-morefile ref="uploading"  upTypes='0' :clears='clears' :fileList='withFileslistTemp' @outputFile="getFilefj" @removeFile='removeFilefj'></upload-morefile>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_groundSupplyreceivePerson')" prop="chargePerson">
          <el-select
            :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_groundSupplyreceivePerson')"
            filterable
            class="selectPerson"
            v-model="form.chargePerson"
            collapse-tags
          >
            <el-option
              v-for="(item,index) in chargePersons"
              :key="index"
              :value="item.id"
              :label="item.idNo"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_groundSupplycopyPerson')" prop="copyPerson">
          <el-select
            multiple
            collapse-tags
            :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_groundSupplycopyPerson')"
            filterable
            class="selectPerson"
            v-model="form.copyPerson"
          >
            <el-option
              v-for="(item,index) in copyPersons"
              :key="index"
              :value="item.id"
              :label="item.idNo"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-button class="btn-first" @click="res('form')">{{$t('lang.btn_rest')}}</el-button>
      <el-button
        :disabled="isDisabled"
        class="detailbtn"
        type="primary"
        @click="onSubmit('form')"
      >{{$t('lang.btn_save')}}</el-button>
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:400backgroundSupply
 *@Description:400后台补单
 *@author:孙斯维
 *@Copyright:格众科技
 *@date:2020-03-17
 */
import uploadmoreFile from '../../../components/upload_morefile.vue'
export default {
  data() {
    var isPhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入联系人电话'))
      } else {
        let regPone = null
        let mobile = /^1(3|4|5|6|7|8|9)\d{9}$/
        // eslint-disable-next-line no-useless-escape
        let tel = /^(0[0-9]{2,3})([2-9][0-9]{4,7})+(\-[0-9]{1,4})?$/
        if (value.charAt(0) == 0) {
          regPone = tel
        } else {
          regPone = mobile
        }
        if (!regPone.test(value)) {
          return callback(new Error("请填写联系人电话(座机格式'区号座机号码')"))
        }
        callback()
        }
      //   if (value === '') {
      //   callback(
      //     new Error(
      //       this.$i18n.t('lang.lab_please_Input') +
      //         this.$i18n.t('lang.lab_phoneNum')
      //     )
      //   )
      // } else {
			// 	callback(
			// 		new Error(this.$i18n.t('lang.lab_inputDutyPersonPhoneIsTrue'))
			// 	)
      // }
    }
    var valligeCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$i18n.t('lang.lab_chooseGarden')))
      } else {
        callback()
      }
    }
    var floorCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$i18n.t('lang.lab_selectHouse')))
      } else {
        callback()
      }
    }
    var unitCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$i18n.t('lang.lab_selectUnit')))
      } else {
        callback()
      }
    }
    var roomCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$i18n.t('lang.lab_selectRoom')))
      } else {
        callback()
      }
    }
    var firstLevelCheck = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$i18n.t('lang.lab_firstLevel')))
      } else {
        callback()
      }
    }
    return {
      thirdcomplaintPraiseList:[],
      secondcomplaintPraiseList:[],
      clears: false, // 清空按钮
      accept: '.jpg, .jpeg, .png',
      id: '', // 判断新增还是修改
      isDisabled: false, // 确定按钮置灰
      fileListfj: [], // 附件上传
      fileList: [], // 图片上传
      types: [], // 小区下拉列表
      floorList: [], // 楼层下拉列表
      unitList: [], // 单元下拉列表
      roomList: [], // 房间下拉列表
      type: 1, // 楼号单元号房间号区分
      firstLevellist: [], // 一级分类list
      secondLevellist: [], // 二级分类list
      thirdLevellist: [], // 三级分类list
      typeleval: 1, // 级别接口区分字段
      rules: {
        user: [
          {
            required: true,
            message:
              this.$i18n.t('lang.lab_please_Input') +
              this.$i18n.t('lang.lab_paperusername'),
            trigger: 'blur'
          }
        ],
        tele: [{ required: true, validator: isPhone, trigger: 'blur' }],
        nature: [
          {
            required: true,
            message: this.$i18n.t('lang.lab_complainFlag'),
            trigger: 'change'
          }
        ],
         complaintPraiseType2: [
          {
            required: true,
            message: this.$i18n.t('lang.lab_complaintPraiseType2'),
            trigger: 'change'
          }
        ],
         complaintPraiseType3: [
          {
            required: true,
            message: this.$i18n.t('lang.lab_complaintPraiseType3'),
            trigger: 'change'
          }
        ],
        context: [
          {
            required: true,
            message:
              this.$i18n.t('lang.lab_please_Input') +
              this.$i18n.t('lang.lab_groundSupplycontext'),
            trigger: 'blur'
          }
        ],
        value: [
          {
            required: true,
            validator: valligeCheck,
            trigger: 'change'
          }
        ],
        floorid: [
          {
            required: true,
            validator: floorCheck,
            trigger: 'change'
          }
        ],
        unitid: [
          {
            required: true,
            validator: unitCheck,
            trigger: 'change'
          }
        ],
        roomid: [
          {
            required: true,
            validator: roomCheck,
            trigger: 'change'
          }
        ],
        firstLevelid: [
          {
            required: true,
            validator: firstLevelCheck,
            trigger: 'change'
          }
        ],
      },
      form: {
        tele: '',
        context: '',
        user: '',
        nature: '',
        files: '',
        value: '',
        floorid: '',
        unitid: '',
        roomid: '',
        firstLevelid: '',
        secondLevelid: '',
        thirdLevelid: '',
        searchUnit: [],
        copyPerson: [],
        chargePerson: '',
        complaintPraiseType2:'',
        complaintPraiseType3:''
      }, // 对象
      chargePersons: [], // 责任人list
      copyPersons: [], // 抄送人list
      fileslist: [], // 图片list
      withFileslist: [], // 附件list
      fileListTemp: [], // 图片list
      withFileslistTemp: [], // 附件list
      natures: this.$i18n.t('lang.NewspaperInfoList.complainFlaglist') // 事件性质list
    }
  },
  components: {
		'upload-morefile': uploadmoreFile
  },
  destroyed() {
    window.localStorage.setItem('fourbsform', JSON.stringify(this.form))
    if (this.fileList.length > 0) {
      window.localStorage.setItem('fourbsfileList', JSON.stringify(this.fileList))
    }
     if (this.fileListfj.length > 0) {
      window.localStorage.setItem('fourbsfileListfj', JSON.stringify(this.fileListfj))
    }
  },
  created() {
     if (window.localStorage.getItem('fourbsform')) {
        this.form = JSON.parse(window.localStorage.getItem('fourbsform'))
        this.staffs(this.form.value)
     }
     if (window.localStorage.getItem('fourbsfileList')) {
        this.fileListTemp = JSON.parse(window.localStorage.getItem('fourbsfileList'))
     }
      if (window.localStorage.getItem('fourbsfileListfj')) {
        this.withFileslistTemp = JSON.parse(window.localStorage.getItem('fourbsfileListfj'))
     }
    // 小区下拉
    this.gardens()
    // 一级别下拉
    this.maintainTypes()
    // 事件性质投诉表扬下拉
    this.getValueListByCode()
  },
  methods: {
     selectComplaintpraisetype3(value){
       debugger
       if(value!=""){
         let loading = this.$loading()
        this.$get(
          `/complaintPraiseType?type=3&pageSize=999&pageNo=1&Pid=${value}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
                this.thirdcomplaintPraiseList = res.list
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      
       }
         this.form.complaintPraiseType3='' 
    },
    selectComplaintpraisetype2(value){
      debugger
      if(value==='2'||value==='3'){
      let loading = this.$loading()
      this.$get(
        `/complaintPraiseType?type=2&pageSize=999&pageNo=1&Pid=${value}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
              this.secondcomplaintPraiseList = res.list
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
      }
        this.form.complaintPraiseType2='' 
        this.form.complaintPraiseType3='' 
    },
     // 获取组件值
    getFile(e) {
       this.fileList.push({
        name: '',
        url: e
    })
    },
    // 移除图片
    removeFile(e) {
    let list1 = []
     for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].url === e) {

        } else {
          list1.push(this.fileList[i])
        }
     }
      this.fileList = list1
      this.fileListTemp = JSON.parse(JSON.stringify(list1))
    },
    // 附件获取组件值
    getFilefj(e) {
      this.fileListfj.push({
        name: '',
        url: e
    })
    },
    // 移除附件
    removeFilefj(e) {
    let list2 = []
     for (let i = 0; i < this.fileListfj.length; i++) {
        if (this.fileListfj[i].url === e) {

        } else {
          list2.push(this.fileListfj[i])
        }
     }
      this.fileListfj = list2
      this.withFileslistTemp = JSON.parse(JSON.stringify(list2))
    },
    keyBA() {
      // 仅保留数字和"."
      this.form.tele = this.form.tele.replace(/[^\d]/g, '')
      // 首位是0的话去掉
      // if (this.form.tele.indexOf('.') < 0 && this.form.tele != '') {
      //  this.form.tele = parseFloat(this.form.tele)
     // }
    },
   // 事件性质投诉表扬下拉
    getValueListByCode() {
      let loading = this.$loading()
      this.$get(`/getValueListByCode?code=complainType`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.form.group = res.result
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 小区下拉
    gardens() {
      let loading = this.$loading()
      this.$get(`/gardens`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.types = res.list
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 报事服务分类list
    maintainTypes() {
      let loading = this.$loading()
      this.$get(
        `/maintainTypes?type=${this.typeleval}&pageSize=999&pageNo=1&parentId=${this.$store.getters.gardenId}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            if (this.typeleval === 1) {
              this.firstLevellist = res.list
            }
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 通过级别id查询下一级别list
    levalmaintainTypes(Pid) {
      this.$get(
        `/maintainTypes?type=${this.typeleval}&pageSize=999&pageNo=1&Pid=${Pid}`
      ).then(
        res => {
          if (res && res.errCode === 0) {
            if (this.typeleval === 2) {
              this.secondLevellist = res.list
            } else if (this.typeleval === 3) {
              this.thirdLevellist = res.list
            }
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // id查询楼号楼层房间号
    gardenGrids(gardenid) {
      if (gardenid === '0' || gardenid === '') {
        return
      }
      this.$get(
        `/gardenGrids?type=${this.type}&pageSize=999&pageNo=1&parentId=${gardenid}`
      ).then(
        res => {
          if (res && res.errCode === 0) {
            if (this.type === 1) {
              this.floorList = res.list
            } else if (this.type === 2) {
              this.unitList = res.list
            } else if (this.type === 3) {
              this.roomList = res.list
            }
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 通过小区选择楼号
    selectFloor(value) {
      this.type = 1
      this.form.floorid = ''
      this.form.unitid = ''
      this.form.roomid = ''
      this.unitList = []
      this.roomList = []
      this.floorList = []
      this.gardenGrids(this.form.value)
      this.staffs(this.form.value)
    },
    // 通过楼层选择单元号
    selectUnit(value) {
      this.type = 2
      this.unitList = []
      this.form.unitid = ''
      this.form.roomid = ''
      this.roomList = []
      this.gardenGrids(this.form.floorid)
    },
    // 通过单元选择房间号
    selectRoom(value) {
      this.roomList = []
      this.type = 3
      this.form.roomid = ''
      this.gardenGrids(this.form.unitid)
    },
    // 通过一级别查询二级下拉list
    selectSecond(value) {
      this.typeleval = 2
      this.levalmaintainTypes(this.form.firstLevelid)
      this.form.secondLevelid = ''
      this.form.thirdLevelid = ''
      this.thirdLevellist = []
    },
    // 通过二级别查询三级下拉list
    selectThird(value) {
      this.typeleval = 3
      this.levalmaintainTypes(this.form.secondLevelid)
      this.form.thirdLevelid = ''
    },
    // 责任人抄送人下拉
    staffs(gardenIds) {
      let loading = this.$loading()
      this.$get(`/staffs?pageSize=999&pageNo=1&gardenId=${gardenIds}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.chargePersons = res.list
            this.copyPersons = res.list
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    jump() {
      this.$router.push({ name: '400NewspaperInfoList' })
    },
    // 清空
    res(formName) {
      this.clears = true
      this.$refs.form.clearValidate()
      this.fileList = [] // 图片列表清空
      this.fileListfj = [] // 附件列表清空
      this.form.nature = ''
      this.form.context = ''
      this.form.user = ''
      this.form.tele = ''
      this.form.withFiles = ''
      this.form.files = ''
      this.form.value = ''
      this.form.floorid = ''
      this.form.unitid = ''
      this.form.roomid = ''
      this.form.secondLevelid = ''
      this.form.thirdLevelid = ''
      this.form.firstLevelid = ''
      this.form.chargePerson = ''
      this.form.copyPerson = []
      setTimeout(() => {
        this.$refs[formName].clearValidate()
      }, 500)
    },
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.id === '') {
             // 上传图片
            if (this.fileList.length > 0) {
              for (let i = 0; i < this.fileList.length; i++) {
                this.fileslist.push(this.fileList[i].url)
              }
            }
            // 上传附件
            if (this.fileListfj.length > 0) {
              for (let j = 0; j < this.fileListfj.length; j++) {
                this.withFileslist.push(this.fileListfj[j].url)
              }
            }
            let params = {
              gardenid: this.form.value,
              houseId: this.form.floorid,
              unitId: this.form.unitid,
              roomId: this.form.roomid,
              maintainTypeId1: this.form.firstLevelid,
              maintainTypeId2: this.form.secondLevelid,
              maintainTypeId3: this.form.thirdLevelid,
              mobile: this.form.tele,
              username: this.form.user,
              content: this.form.context,
              files: this.fileslist.toString(),
              withFiles: this.withFileslist.toString(),
              taskType: this.form.nature,
              sendSource: 4,
              complainFlag2: 0,
              staff: this.form.chargePerson, // 责任人
              complainType: this.form.searchUnit.toString(), // 类别
              copyToStaff: this.form.copyPerson.toString(), // 抄送人
              complaintPraiseType2: this.form.complaintPraiseType2.toString(),
              complaintPraiseType3: this.form.complaintPraiseType3.toString()
            }
            let loading = this.$loading()
            this.$post(`/maintains/`, params).then(
              res => {
                loading.close()
                this.res('form')
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))                  
                  this.$router.push({ name: '400NewspaperInfoList' })
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
.backgroundSupply .el-form-item__content {
  width: 60vw !important;
}
.backgroundSupply .martop {
  margin-top: 20px;
  margin-left: 20px;
}
</style>